import React from 'react';
import Logo from './Logo';

export default function MainNav(props) {
  const LinkCompornent = props.linkComponent;
  const unauthenticatedLinks = [
    {
      label: 'Home',
      href: '/',
    },
    {
      label: 'Credit Builder',
      href: '/credit-builder',
    },
    {
      label: 'Homebuyer',
      href: '/homebuyer-mortgage',
    },
    {
      label: 'Insurance',
      href: '/landing-insurance',
    },
    {
      label: 'ID Fraud Monitor',
      href: '/fraud-monitor',
    },
    {
      label: 'Blog',
      href: '/blog/',
    },
  ];
  const authenticatedLinks = [
    {
      label: 'Overview',
      href: '/home',
    },
    {
      label: 'Homebuyer',
      href: '/mortgage',
    },
    {
      label: 'Loans',
      href: '/offers/personal-loans',
    },
    {
      label: 'Credit Card',
      href: '/offers/credit-cards',
    },
    {
      label: 'Insurance',
      href: '/landing-insurance',
    },
    {
      label: 'Fraud',
      href: '/fraud',
    },
    {
      label: 'Blog',
      href: '/blog/',
    },
  ];
  const verifiedLinks = [
    {
      label: 'Overview',
      href: '/home',
    },
    {
      label: 'Homebuyer',
      href: '/mortgage',
    },
    {
      label: 'Loans',
      href: '/offers/personal-loans',
    },
    {
      label: 'Credit Card',
      href: '/offers/credit-cards',
    },
    {
      label: 'Insurance',
      href: '/landing-insurance',
    },
    {
      label: 'Fraud',
      href: '/fraud',
    },
    {
      label: 'Blog',
      href: '/blog/',
    },
  ];
  const navItems = !props.isAuthenticated
    ? unauthenticatedLinks
    : props.isVerified
    ? verifiedLinks
    : authenticatedLinks;

  function getActive(pathname, href, label) {
    let active = false;
    if (href === '/fraud-watch' && pathname === '/fraud-watch') {
      active = true;
    } else if (
      href === 'home' &&
      pathname.indexOf('/home') === 0 &&
      pathname !== '/home/fraud-watch'
    ) {
      active = true;
    } else if (
      href === 'offers/personal-loans' &&
      pathname.indexOf('/offers/personal-loans') === 0
    ) {
      active = true;
    } else if (
      href === 'offers/credit-cards' &&
      pathname.indexOf('/offers/credit-cards') === 0
    ) {
      active = true;
    } else if (href === 'mortgage' && pathname.indexOf('/mortgage') === 0) {
      active = true;
    } else if (href === '' && pathname && pathname === '/') {
      active = true;
    } else if (
      href === 'homebuyer-mortgage' &&
      pathname.indexOf('/homebuyer-mortgage') === 0
    ) {
      active = true;
    } else if (
      href === 'credit-builder' &&
      pathname.indexOf('/credit-builder') === 0
    ) {
      active = true;
    } else if (
      href === 'landing-insurance' &&
      pathname.indexOf('/landing-insurance') === 0
    ) {
      active = true;
    } else if (
      href === 'fraud-monitor' &&
      pathname.indexOf('/fraud-monitor') === 0
    ) {
      active = true;
    } else if (label === 'Fraud' && pathname.indexOf('/fraud') === 0) {
      active = true;
    } else if (href === '/blog/' && pathname.indexOf('/blog') === 0) {
      active = true;
    } else if (
      label === 'Overview' &&
      (pathname.indexOf('/home/credit-dashboard') === 0 ||
        pathname.indexOf('/home/credit-dashboard/take-action') === 0 ||
        pathname.indexOf('/home/credit-dashboard/stay-in-the-know') === 0 ||
        pathname.indexOf('/home/credit-check') === 0 ||
        pathname.indexOf('/home/credit-check/need-attention') === 0 ||
        pathname.indexOf('/home/credit-check/see-all') === 0 ||
        pathname.indexOf('/home/credit-factors/credit-cards') === 0 ||
        pathname.indexOf('/home/credit-factors/short-term-credit') === 0 ||
        pathname.indexOf('/home/credit-factors/payment-history') === 0 ||
        pathname.indexOf('/home/credit-factors/total-accounts') === 0 ||
        pathname.indexOf('/home/credit-factors/bad-credit') === 0 ||
        pathname.indexOf('/home/credit-factors/stability') === 0 ||
        pathname.indexOf('/home/credit-report/all-debts') === 0 ||
        pathname.indexOf('/home/credit-report/arrears') === 0 ||
        pathname.indexOf('/home/credit-report/bad-credit') === 0 ||
        pathname.indexOf('/home/credit-booster') === 0 ||
        pathname.indexOf('/home/credit-booster/blockers') === 0 ||
        // pathname.indexOf('/home/fraud-monitor') === 0 ||
        pathname.indexOf('/home/summary/history') === 0 ||
        pathname.indexOf('/home/dashboard') === 0)
    ) {
      active = true;
    }
    return active;
  }

  return (
    <header
      className={`header position-fixed w-100$ ${
        props.slide ? 'slided' : null
      }`}
    >
      <div className='container container_header'>
        <section className='header__box'>
          <Logo {...props} />
          <nav className='header__nav'>
            <ul className={`top-navigation header__links `}>
              {navItems.map((item, key) => {
                const { label, href, ...linkProps } = item;
                const active = getActive(props.pathname, href, label);
                return (
                  <li
                    key={key}
                    className={`top-navigation__item ${active ? 'active' : ''}`}
                  >
                    <LinkCompornent
                      href={href}
                      className='top-navigation__link'
                    >
                      {active && '*'}
                      {label}
                      {linkProps.new && (
                        <span className='top-navigation__new'>New</span>
                      )}
                      {linkProps.beta && (
                        <span className='top-navigation__new'>Beta</span>
                      )}
                      {item.arrow && (
                        <>
                          &nbsp;
                          <i className='fa fa-chevron-down' />
                        </>
                      )}
                      <span className='top-navigation__highlight'>&nbsp;</span>
                    </LinkCompornent>
                  </li>
                );
              })}
            </ul>
          </nav>
        </section>
      </div>
    </header>
  );
}
